 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER501HAPPYNONE from '@/components/0_chapter501happynone'
 import A_CHAPTER502BIGLIAR from '@/components/1_chapter502bigliar'
 import A_CHAPTER503SECONDOBJECTIVE from '@/components/2_chapter503secondobjective'
 import A_CHAPTER504OTHERDISLIKES from '@/components/3_chapter504otherdislikes'
 import A_CHAPTER505UNWORTHYTOAPPEAR from '@/components/4_chapter505unworthytoappear'
 import A_CHAPTER506ABNORMALENOUGH from '@/components/5_chapter506abnormalenough'
 import A_CHAPTER507UNPARALLELEDUNDERHEAVEN from '@/components/6_chapter507unparalleledunderheaven'
 import A_CHAPTER508LYINGGUN from '@/components/7_chapter508lyinggun'
 import A_CHAPTER509ITWASMOREIMPORTANTFORHIMTOHAVETHESTRENGTHNOW from '@/components/8_chapter509itwasmoreimportantforhimtohavethestrengthnow'
 import A_CHAPTER510BRACE from '@/components/9_chapter510brace'
 import A0_CHAPTER511PROMOTIONCOMPETITION from '@/components/10_chapter511promotioncompetition'
 import A1_CHAPTER512IADVISEYOUTOBEKIND from '@/components/11_chapter512iadviseyoutobekind'
 import A2_CHAPTER513DISTINGUISHEDMEMBER from '@/components/12_chapter513distinguishedmember'
 import A3_CHAPTER514IILGIVEYOUYOURSHOES from '@/components/13_chapter514iilgiveyouyourshoes'
 import A4_CHAPTER515ICANTLOSEMYSPIRIT from '@/components/14_chapter515icantlosemyspirit'
 import A5_CHAPTER516THECHAMPIONLAUGHEDATTHEMADDOG from '@/components/15_chapter516thechampionlaughedatthemaddog'
 import A6_CHAPTER517WHATAHUGEPIT from '@/components/16_chapter517whatahugepit'
 import A7_CHAPTER518OLDFOX from '@/components/17_chapter518oldfox'
 import A8_CHAPTER519WHATSSOSCARYABOUTLOSING from '@/components/18_chapter519whatssoscaryaboutlosing'
 import A9_CHAPTER520MYOWNMONEY from '@/components/19_chapter520myownmoney'
 import A0_CHAPTER521CRESCENTPORCELAIN from '@/components/20_chapter521crescentporcelain'
 import A1_CHAPTER522LONGTIMENOSEE from '@/components/21_chapter522longtimenosee'
 import A2_CHAPTER523EYEOPENING from '@/components/22_chapter523eyeopening'
 import A3_CHAPTER524AWASTE from '@/components/23_chapter524awaste'
 import A4_CHAPTER525GROWINGUP from '@/components/24_chapter525growingup'
 import A5_CHAPTER526AROBOTHASNOEMOTION from '@/components/25_chapter526arobothasnoemotion'
 import A6_CHAPTER527LETHERBERED from '@/components/26_chapter527letherbered'
 import A7_CHAPTER528MYHEARTISABOUTTOEXPLODE from '@/components/27_chapter528myheartisabouttoexplode'
 import A8_CHAPTER529SURFUP from '@/components/28_chapter529surfup'
 import A9_CHAPTER530MUSTBERED from '@/components/29_chapter530mustbered'
 import A0_CHAPTER531INEVERLIE from '@/components/30_chapter531ineverlie'
 import A1_CHAPTER532HEWANTSTOMARRYHERTOO from '@/components/31_chapter532hewantstomarryhertoo'
 import A2_CHAPTER533NONSENSE from '@/components/32_chapter533nonsense'
 import A3_CHAPTER534HOWMANYIDIOTSCANTHEREBE from '@/components/33_chapter534howmanyidiotscantherebe'
 import A4_CHAPTER535PROTECTOR from '@/components/34_chapter535protector'
 import A5_CHAPTER536HAMMERHEAD from '@/components/35_chapter536hammerhead'
 import A6_CHAPTER537TRUELOVE from '@/components/36_chapter537truelove'
 import A7_CHAPTER538WHATALUNATIC from '@/components/37_chapter538whatalunatic'
 import A8_CHAPTER539WHATAGENIUS from '@/components/38_chapter539whatagenius'
 import A9_CHAPTER540UNKNOWINGISFEARLESS from '@/components/39_chapter540unknowingisfearless'
 import A0_CHAPTER541ULTRABULLDOZER from '@/components/40_chapter541ultrabulldozer'
 import A1_CHAPTER542WORKWITHTOOMUCHEFFORT from '@/components/41_chapter542workwithtoomucheffort'
 import A2_CHAPTER543PLAGIODON from '@/components/42_chapter543plagiodon'
 import A3_CHAPTER544IWILLKILLYOUWHENIMFAT from '@/components/43_chapter544iwillkillyouwhenimfat'
 import A4_CHAPTER545LOOKINGFORWARDTOIT from '@/components/44_chapter545lookingforwardtoit'
 import A5_CHAPTER546CONQUERHER from '@/components/45_chapter546conquerher'
 import A6_CHAPTER547DONTPISSMEOFF from '@/components/46_chapter547dontpissmeoff'
 import A7_CHAPTER548LOSSYSTROKE from '@/components/47_chapter548lossystroke'
 import A8_CHAPTER549SUCHRUTHLESSNESS from '@/components/48_chapter549suchruthlessness'
 import A9_CHAPTER550APICALPOSITION from '@/components/49_chapter550apicalposition'
 import A0_CHAPTER551DROPINTOPIT from '@/components/50_chapter551dropintopit'
 import A1_CHAPTER552DONTYOUWANTTOLOSEFACE from '@/components/51_chapter552dontyouwanttoloseface'
 import A2_CHAPTER553TRYINGTOCATCHHER from '@/components/52_chapter553tryingtocatchher'
 import A3_CHAPTER554WHATTHEHECK from '@/components/53_chapter554whattheheck'
 import A4_CHAPTER555TAUGHTTOBEHUMAN from '@/components/54_chapter555taughttobehuman'
 import A5_CHAPTER556YOUHAVETODOTHEWHOLETHINGINAPLAY from '@/components/55_chapter556youhavetodothewholethinginaplay'
 import A6_CHAPTER557LIFEANDDEATHFEUD from '@/components/56_chapter557lifeanddeathfeud'
 import A7_CHAPTER558HARDNUCLEUSCONFESSION from '@/components/57_chapter558hardnucleusconfession'
 import A8_CHAPTER559NEVER from '@/components/58_chapter559never'
 import A9_CHAPTER560INFLUENZACANKILLPEOPLETOO from '@/components/59_chapter560influenzacankillpeopletoo'
 import A0_CHAPTER561ANIMAL from '@/components/60_chapter561animal'
 import A1_CHAPTER562NOTSMARTENOUGH from '@/components/61_chapter562notsmartenough'
 import A2_CHAPTER563IMAFRAID from '@/components/62_chapter563imafraid'
 import A3_CHAPTER564UNHAPPY from '@/components/63_chapter564unhappy'
 import A4_CHAPTER565ANIGHTOFSUDDENWEALTH from '@/components/64_chapter565anightofsuddenwealth'
 import A5_CHAPTER566WHATISCONSCIENCE from '@/components/65_chapter566whatisconscience'
 import A6_CHAPTER567ACROBIN from '@/components/66_chapter567acrobin'
 import A7_CHAPTER568SHEISTHESTARINTHESKY from '@/components/67_chapter568sheisthestarinthesky'
 import A8_CHAPTER569HANZIANSUNIQUE from '@/components/68_chapter569hanziansunique'
 import A9_CHAPTER570NOTAKING from '@/components/69_chapter570notaking'
 import A0_CHAPTER571FACE from '@/components/70_chapter571face'
 import A1_CHAPTER572NATURALTOLERANCE from '@/components/71_chapter572naturaltolerance'
 import A2_CHAPTER573ITMUSTBETRUELOVE from '@/components/72_chapter573itmustbetruelove'
 import A3_CHAPTER574LIKEHIM from '@/components/73_chapter574likehim'
 import A4_CHAPTER575CLANDESTINELOVE from '@/components/74_chapter575clandestinelove'
 import A5_CHAPTER576CANINETAPE from '@/components/75_chapter576caninetape'
 import A6_CHAPTER577VINEGAR from '@/components/76_chapter577vinegar'
 import A7_CHAPTER578THERESACHANCEOFBECOMINGFAMOUS from '@/components/77_chapter578theresachanceofbecomingfamous'
 import A8_CHAPTER579DONOTLIGHTTHELAMP from '@/components/78_chapter579donotlightthelamp'
 import A9_CHAPTER580ITWASSOSEDUCTIVE from '@/components/79_chapter580itwassoseductive'
 import A0_CHAPTER581SENDINGBUDDHATOTHEWEST from '@/components/80_chapter581sendingbuddhatothewest'
 import A1_CHAPTER582EXTERMINATEHER from '@/components/81_chapter582exterminateher'
 import A2_CHAPTER583AMATEURTOEXPLOSION from '@/components/82_chapter583amateurtoexplosion'
 import A3_CHAPTER584TOOAMAZING from '@/components/83_chapter584tooamazing'
 import A4_CHAPTER585ICANTACCEPTTHIS from '@/components/84_chapter585icantacceptthis'
 import A5_CHAPTER586VERYREASONABLE from '@/components/85_chapter586veryreasonable'
 import A6_CHAPTER587YEARNINGFORBEAUTY from '@/components/86_chapter587yearningforbeauty'
 import A7_CHAPTER588DONTBECOMPLACENT from '@/components/87_chapter588dontbecomplacent'
 import A8_CHAPTER589SHAMELESS from '@/components/88_chapter589shameless'
 import A9_CHAPTER590FACECHANGINGESSENCE from '@/components/89_chapter590facechangingessence'
 import A0_CHAPTER591PARANOIA from '@/components/90_chapter591paranoia'
 import A1_CHAPTER592BASTARD from '@/components/91_chapter592bastard'
 import A2_CHAPTER593THERESPONSIBILITYOFFART from '@/components/92_chapter593theresponsibilityoffart'
 import A3_CHAPTER594BUFFWITHRED from '@/components/93_chapter594buffwithred'
 import A4_CHAPTER595THEYAREALLOLDFOXES from '@/components/94_chapter595theyarealloldfoxes'
 import A5_CHAPTER596HECANTAFFORDTOPAY from '@/components/95_chapter596hecantaffordtopay'
 import A6_CHAPTER597MOVEHEADER from '@/components/96_chapter597moveheader'
 import A7_CHAPTER598DISGUSTED from '@/components/97_chapter598disgusted'
 import A8_CHAPTER599GREATGRIEVANCE from '@/components/98_chapter599greatgrievance'
 import A9_CHAPTER600IFYOUARENOTENEMIESDONTMEETUP from '@/components/99_chapter600ifyouarenotenemiesdontmeetup'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter501happynone",
 			"name" : "0_chapter501happynone",
 			"component" : A_CHAPTER501HAPPYNONE
 		},
 		{
 			"path" : "/1_chapter502bigliar",
 			"name" : "1_chapter502bigliar",
 			"component" : A_CHAPTER502BIGLIAR
 		},
 		{
 			"path" : "/2_chapter503secondobjective",
 			"name" : "2_chapter503secondobjective",
 			"component" : A_CHAPTER503SECONDOBJECTIVE
 		},
 		{
 			"path" : "/3_chapter504otherdislikes",
 			"name" : "3_chapter504otherdislikes",
 			"component" : A_CHAPTER504OTHERDISLIKES
 		},
 		{
 			"path" : "/4_chapter505unworthytoappear",
 			"name" : "4_chapter505unworthytoappear",
 			"component" : A_CHAPTER505UNWORTHYTOAPPEAR
 		},
 		{
 			"path" : "/5_chapter506abnormalenough",
 			"name" : "5_chapter506abnormalenough",
 			"component" : A_CHAPTER506ABNORMALENOUGH
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js